import React from "react";
import { Form, Input, Button, Modal, Grid } from "antd";

// Invest Modal
const InvestModal = ({ visible, onCancel }) => {
  const [form] = Form.useForm();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleInvestment = (values) => {
    console.log("Investment values:", values);
    // Handle investment logic here
    onCancel();
  };

  return (
    <Modal
      title="Invest Now"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={isMobile ? "90%" : 520}
    >
      <Form form={form} layout="vertical" onFinish={handleInvestment}>
        <Form.Item
          label="Investment Amount"
          name="investmentAmount"
          rules={[
            { required: true, message: "Please enter the investment amount!" },
          ]}
        >
          <Input prefix="K" type="number" />
        </Form.Item>

        <Form.Item
          label="Investment Plan"
          name="investmentPlan"
          rules={[
            { required: true, message: "Please select an investment plan!" },
          ]}
        >
          <Input placeholder="e.g., Fixed Deposit, Mutual Fund" />
        </Form.Item>

        <Form.Item
          label="Duration"
          name="duration"
          rules={[
            {
              required: true,
              message: "Please select the investment duration!",
            },
          ]}
        >
          <Input placeholder="e.g., 6 months, 1 year" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Invest Now
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InvestModal;
